import { render, staticRenderFns } from "./AttachmentVerbale.vue?vue&type=template&id=45be958d"
import script from "./AttachmentVerbale.vue?vue&type=script&lang=js"
export * from "./AttachmentVerbale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports